// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.donatie-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
  animation: fadeIn 0.2s ease;
}

.donatie-modal {
  background: #1a1a1a;
  border: 2px solid #f4b400;
  border-radius: 20px;
  padding: 36px 32px;
  max-width: 440px;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  text-align: center;
  box-shadow: 0 0 40px rgba(244, 180, 0, 0.2);
  animation: slideUp 0.25s ease;
}

.donatie-close {
  position: absolute;
  top: 14px;
  right: 14px;
  background: none;
  border: none;
  color: #aaa;
  font-size: 18px;
  cursor: pointer;
}
.donatie-close:hover { color: white; }

.donatie-header h2 {
  color: white;
  font-size: 22px;
  margin: 10px 0 6px;
}
.donatie-header p {
  color: #aaa;
  font-size: 14px;
  line-height: 1.6;
}

.donatie-split-info {
  display: flex;
  align-items: center;
  gap: 16px;
  background: #2a2a2a;
  border-radius: 12px;
  padding: 16px 20px;
  width: 100%;
}

.split-item {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1;
}
.split-item div {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.split-item strong {
  color: #f4b400;
  font-size: 18px;
}
.split-item span {
  color: #aaa;
  font-size: 12px;
}

.split-divider {
  width: 1px;
  height: 40px;
  background: #444;
}

.donatie-sume {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
}

.donatie-suma-btn {
  padding: 14px 28px;
  background: transparent;
  border: 2px solid #f4b400;
  color: #f4b400;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 100px;
}
.donatie-suma-btn:hover,
.donatie-suma-btn.activ {
  background: #f4b400;
  color: #1a1a1a;
}
.donatie-suma-btn:disabled { opacity: 0.6; cursor: not-allowed; }

.donatie-footer {
  color: #555;
  font-size: 12px;
}

@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes slideUp {
  from { transform: translateY(30px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}`, "",{"version":3,"sources":["webpack://./src/components/DonatieModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;AACjB;AACA,uBAAuB,YAAY,EAAE;;AAErC;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;AACA,6BAA6B,YAAY,EAAE,mBAAmB,EAAE;;AAEhE;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,oBAAoB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;AAC5D;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C","sourcesContent":[".donatie-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.65);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  padding: 20px;\n  animation: fadeIn 0.2s ease;\n}\n\n.donatie-modal {\n  background: #1a1a1a;\n  border: 2px solid #f4b400;\n  border-radius: 20px;\n  padding: 36px 32px;\n  max-width: 440px;\n  width: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  align-items: center;\n  text-align: center;\n  box-shadow: 0 0 40px rgba(244, 180, 0, 0.2);\n  animation: slideUp 0.25s ease;\n}\n\n.donatie-close {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  background: none;\n  border: none;\n  color: #aaa;\n  font-size: 18px;\n  cursor: pointer;\n}\n.donatie-close:hover { color: white; }\n\n.donatie-header h2 {\n  color: white;\n  font-size: 22px;\n  margin: 10px 0 6px;\n}\n.donatie-header p {\n  color: #aaa;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.donatie-split-info {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  background: #2a2a2a;\n  border-radius: 12px;\n  padding: 16px 20px;\n  width: 100%;\n}\n\n.split-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n}\n.split-item div {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n}\n.split-item strong {\n  color: #f4b400;\n  font-size: 18px;\n}\n.split-item span {\n  color: #aaa;\n  font-size: 12px;\n}\n\n.split-divider {\n  width: 1px;\n  height: 40px;\n  background: #444;\n}\n\n.donatie-sume {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.donatie-suma-btn {\n  padding: 14px 28px;\n  background: transparent;\n  border: 2px solid #f4b400;\n  color: #f4b400;\n  border-radius: 12px;\n  font-size: 18px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s;\n  min-width: 100px;\n}\n.donatie-suma-btn:hover,\n.donatie-suma-btn.activ {\n  background: #f4b400;\n  color: #1a1a1a;\n}\n.donatie-suma-btn:disabled { opacity: 0.6; cursor: not-allowed; }\n\n.donatie-footer {\n  color: #555;\n  font-size: 12px;\n}\n\n@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }\n@keyframes slideUp {\n  from { transform: translateY(30px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
